/* unplugin-vue-components disabled */import { render } from "./AuthLinksTable.vue?vue&type=template&id=4475204a&scoped=true&ts=true"
import script from "./AuthLinksTable.vue?vue&type=script&lang=ts"
export * from "./AuthLinksTable.vue?vue&type=script&lang=ts"

import "./AuthLinksTable.vue?vue&type=style&index=0&id=4475204a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4475204a"]])

export default __exports__